var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineBlend2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.92 16.67c-3.8-.5-6.7-3.8-6.7-7.67 0-4.27 3.48-7.75 7.75-7.75 3.87 0 7.17 2.89 7.67 6.72.05.3.08.64.08 1.03 0 4.27-3.47 7.75-7.75 7.75-.39 0-.73-.03-1.05-.08zM2.72 9a6.26 6.26 0 0 0 5.42 6.19c.26.04.53.06.83.06 3.45 0 6.25-2.8 6.25-6.25 0-.3-.02-.57-.06-.81a6.254 6.254 0 0 0-6.19-5.44c-3.45 0-6.25 2.8-6.25 6.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3 16.03a.747.747 0 0 1 .87-.84c.24.04.5.06.8.06 3.45 0 6.25-2.8 6.25-6.25 0-.3-.02-.57-.06-.81-.04-.23.04-.47.2-.64.16-.17.39-.26.64-.22 3.83.5 6.72 3.8 6.72 7.67 0 4.27-3.47 7.75-7.75 7.75-3.87 0-7.17-2.89-7.67-6.72zm7.67 5.22c3.45 0 6.25-2.8 6.25-6.25 0-2.8-1.88-5.24-4.5-5.99 0 4.26-3.47 7.74-7.74 7.74.76 2.62 3.19 4.5 5.99 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.9 15.95-1.3-1.28a.755.755 0 0 1-.01-1.06c.29-.29.76-.3 1.06-.01l1.3 1.28c.29.29.3.77.01 1.06-.14.14-.34.22-.53.22s-.38-.07-.53-.21zM16.44 12.53l-1-1a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1 1c.29.29.29.77 0 1.06a.71.71 0 0 1-.53.22c-.19 0-.38-.07-.53-.22zM11.44 17.53l-1-1a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1 1c.29.29.29.77 0 1.06a.71.71 0 0 1-.53.22c-.19 0-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBlend2);
export default __webpack_public_path__ + "static/media/vuesax-outline-blend-2.80604dc1b7b620ec89aed8843e2083f3.svg";
export { ForwardRef as ReactComponent };